import { apiFuns } from "sw-hic";
let api = {
  Standard: apiFuns.genStandard("standard", "/api/therapy"),
};
export default api;
